import React, { useState } from "react";
import PurchaseIcon from "../../assets/icons/boomerang_element-01.svg2";
import RenewIcon from "../../assets/icons/calendar.svg2";
import { Button } from "react-bootstrap";
import { usePurchaseSolutionMutation } from "../store/slices/settingsSlice";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

export default function SolutionPurchaseOptions({ solution }) {
  const [purchasing, setPurchasing] = useState(false);
  const [purchase] = usePurchaseSolutionMutation();
  const navigate = useNavigate();


  return (
    <div className="bg-icon rounded-3 p-3">
      <div className="fw-bold text-center fs-4">
        <PurchaseIcon width={30} className="m-2" /> Purchase options:
        <hr className="text-secondary" />
      </div>
      <div className="d-flex align-items-center justify-content-evenly">
        <div>
          <div className="fs-5 fw-bold">Template price:</div>
          <div>
            <span className="fw-bold fs-1 text-blue">£25.99</span>
            <span className="fw-bold">+VAT</span>
          </div>
          <div>
            <RenewIcon width={20} className="me-2" />
            <span>Renews at £25.99 each month</span>
          </div>
        </div>
        <div>
          <div className="fw-bold fs-5 mb-2">Billing freuqency:</div>

          <select
            aria-label="Default select example"
            className="border-0 p-2 py-1 rounded-3 fw-bold mx-3"
          >
            <option>MONTLY</option>
            <option value="1">WEEKLY</option>
            <option value="2">YEARLY</option>
            <option value="3">FORTNIGHTLY</option>
          </select>
        </div>
      </div>
      <hr className="my-2" />
      <div className="text-center">
        <Button
          className="bg-black rounded-pill mt-4 w-50 py-3 fw-bold"
          onClick={async () => {
            setPurchasing(true);
            await purchase({
              SolutionUuid: solution.Uuid,
            }).then((response) => {
              setTimeout(() => {
                setPurchasing(false);
                // navigate(`/library/solutions/${solution.Uuid}/details`);
              }, 700);
              if ("data" in response === false) {
                toast.error("Error purchasing solution");
                return;
              }
              toast.success("Solution purchased successfully");
            });
          }}
          disabled={purchasing}
        >
          <PurchaseIcon width={25} className=" purple rounded-circle p-1" />
          Purchase Solution
          {purchasing ? (
            <FontAwesomeIcon icon={faSpinner} className="ms-2" spin />
          ) : (
            ""
          )}
        </Button>
        <br />
        <span className="small">
          You pay £25.99 today. Your next billing day will be on 30/ 09/2026.
        </span>
      </div>
    </div>
  );
}
